<div class="fl-column">
  <h1>{{ 'SENSITIVITY.AI.title' | anessaTranslation: trigger }}</h1>
  <div class="edit-col">
    <h3 class="no-default-margin">
      {{'SENSITIVITY.AI.value_of_target' | anessaTranslation: trigger}}
    </h3>
    <mat-form-field class="pseudo-uv-fonts">
      <mat-select
        id="sensitivity-result-resultSet_select_ai"
        panelClass="sensitivity-ai-select-panel"
        disableOptionCentering
        [placeholder]="'SENSITIVITY.RESULTS.SELECTED_RESULT_SET_AI' | anessaTranslation: trigger"
        [(value)]="selectedResultForAI"
      >
        <ng-container *ngFor="let type of resultTypes">
          <mat-option
            [value]="type">{{ type | anessaTranslation: trigger}}
          </mat-option>
        </ng-container>
      </mat-select>
    </mat-form-field>
  </div>

  <div class="edit-col">
    <div class="pseudo-uv">
      <mat-form-field>
        <input
          matInput
          name="expectedY"
          [placeholder]="'PROJECT.COMMON.PLEASE_ENTER' | anessaTranslation: trigger"
          [(ngModel)]="expectedY"
        >
      </mat-form-field>

      <!-- Units and Currency -->
      @if(showUnitTypeDropdownForAI()) {
        <mat-form-field>
          <mat-select
            panelClass="sensitivity-ai-select-panel"
            disableOptionCentering
            (selectionChange)="clearPrediction()"
            [placeholder]="'RESULTS.GENERAL.SET_UNIT_LOCAL' | anessaTranslation: trigger"
            [(value)]="selectedUnitsTypeForAI"
            >
            <ng-container *ngFor="let type of unitsTypes">
              <mat-option
                [value]="type.value"
              >
                {{ type.translationId | anessaTranslation: trigger}}
              </mat-option>
            </ng-container>
          </mat-select>
        </mat-form-field>
      } @else if(currencyUnitsLoaded && showCurrencyUnitsDropdownForAI()) {
        <mat-form-field>
          <mat-select
            panelClass="sensitivity-ai-select-panel"
            disableOptionCentering
            (selectionChange)="clearPrediction()"
            [placeholder]="'RESULTS.GENERAL.SET_CURRENCY' | anessaTranslation: trigger"
            [(value)]="selectedCurrencyUnitForAI"
          >
            <ng-container *ngFor="let unit of currencyUnits">
              <mat-option
                [value]="unit"
              >
                {{ unit.translationId | anessaTranslation: trigger }}
              </mat-option>
            </ng-container>
          </mat-select>
        </mat-form-field>
      } @else { <!-- Display either nothing or a %  -->
        <mat-form-field>
          <mat-select [disabled]="true" value="single_unit">
            <mat-option value="single_unit">{{ getSingleUnitValue() }}</mat-option>
          </mat-select>
        </mat-form-field>
      }
    </div>
  </div>

  <div class="edit-col">
    <h3 class="no-default-margin">
      {{'SENSITIVITY.AI.variable_to_adjust' | anessaTranslation: trigger}}
    </h3>
    <mat-form-field class="pseudo-uv-fonts">
      <mat-select
        id="sensitivity-result-parameters_select_ai"
        panelClass="sensitivity-ai-select-panel"
        disableOptionCentering
        (selectionChange)="clearPrediction()"
        [placeholder]="'SENSITIVITY.RESULTS.SELECTED_PARAMS_PLACEHOLDER_AI' | anessaTranslation: trigger"
        [(value)]="outputParametersForAI"
      >
        <ng-container *ngFor="let type of parameters">
          <mat-option
            [value]="type"
            [matTooltip]="type">{{ type | anessaTranslation: trigger}}
          </mat-option>
        </ng-container>
      </mat-select>
    </mat-form-field>
  </div>

  <button
    mat-button
    class="btn-compact calculate"
    type="button"
    (click)="onSave()"
    anessaTranslation="COMMON.CALCULATE"
  ></button>


  <div class="edit-col">
    <h3 class="flex-container no-default-margin padding-top-30">
      {{'SENSITIVITY.AI.result_header' | anessaTranslation: trigger}}
      <mat-icon
        [matTooltip]="('SENSITIVITY.AI.result_tooltip' | anessaTranslation)"
        class="anessa-grey margin-left-10"
      >help</mat-icon>
    </h3>

    <div class="flex-container pseudo-uv override-disabled-color">
      <mat-form-field>
        <input
          matInput
          [(ngModel)]="desiredX"
          [disabled]="true">
      </mat-form-field>
      <mat-form-field>
        <input
          matInput
          [(ngModel)]="desiredUnits"
          [disabled]="true">
      </mat-form-field>
    </div>
  </div>
</div>
